// extracted by mini-css-extract-plugin
module.exports = {"text":"title-l_text__Aesyj"};